export default __webpack_public_path__ + "static/media/AtomsAndCompounds _12.11ac60cf.png";